import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CityDropdownComponent } from './city-dropdown.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
  ],
  declarations: [CityDropdownComponent],
  exports: [CityDropdownComponent]
})
export class CityDropdownModule { }
